import { Component, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { InternalFilterGroup, FilterItem } from 'app/shared/models/filter-group.models';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { PointOfSaleService } from 'app/back-office/shared/services/back-office/pointOfSale.service';
import { FilterMapper } from 'app/back-office/shared/utilities/filter-mapper';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';

@Component({
    selector: 'app-city-filter',
    templateUrl: './city-filter.component.html',
    styleUrls: ['./city-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CityFilterComponent implements OnInit {
  @Input() filter: InternalFilterGroup;
  @Input() accordionState: boolean;
  loaderId = UtilityFunctions.newGuid();

  searchSettings: SearchSettings = {
    placeholder: 'Search city...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
  };

  totalCount = 0;
  searchValue = '';
  cacheFilterData: FilterItem[];
  dataToView: FilterItem[] = [];
  constructor(
    private pointOfSaleService: PointOfSaleService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.accordionState && this.accordionState && this.dataToView.length === 0) {
      this.pointOfSaleService.getAllLocation(this.loaderId, this.searchValue).subscribe(res => {
        this.cacheFilterData = [new FilterItem({ text: 'STATUS.ALL', value: null }), ...FilterMapper.cityFilter(res.items)];
        this.totalCount = this.cacheFilterData.length + 1;
        this.setDataToView(0);
      });
    }
  }

  ngOnInit(): void {

  }

  onSearch(search: string) {
    this.searchValue = search;
    this.setDataToView(0);
  }

  setDataToView(startSlice: number) {
    const dataToSlice = this.cacheFilterData.filter(element => {
      let isMatch = true;
      if (this.searchValue) {
        const search = this.searchValue.toLowerCase();
        isMatch = element.text?.toLowerCase().indexOf(search) >= 0;
      }
      // More filters
      return isMatch;
    });
    if (this.filter.withPagination) {
      const dataToView = dataToSlice.slice(startSlice, startSlice + 10);
      this.dataToView = dataToView;
    } else {
      this.dataToView = dataToSlice;
    }
  }

  getNextData(skipCount: number) {
    if (this.totalCount > skipCount) {
      const next = skipCount ? skipCount - 1 : skipCount;
      this.setDataToView(next);
    }
  }

}
